<template>
  <div class="page height-full">
    <md-dialog :md-active.sync="showDialog" class="md-dialog-container">
      <md-dialog-title>New Account</md-dialog-title>
      <md-dialog-content class="dialog-content">
        <b-form-group
          id="input-group-1"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="form.name"
            type="text"
            required
            placeholder="Company name"
          />
          <b-form-input
            class="mt-2"
            v-model="form.googleDriveUrl"
            type="text"
            required
            placeholder="Google Drive URL"
          />
          <p class="mt-2">Please paste the full link for the Google Drive folder where the client will share content.</p>
        </b-form-group>

        <h4>Engagement Type</h4>
        <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
          <b-form-select 
            class="mt-3" 
            v-model="selectedEngagementType"
            :options="engagementOptions"></b-form-select>
        </b-input-group>

        <b-input-group prepend="$" class="mt-3 mb-2 mr-sm-2 mb-sm-0">
          <b-input 
            id="inline-form-input-setup-amount"  
            type="number" 
            placeholder="Setup Fee"
            v-model="form.setupFee"></b-input>
        </b-input-group>

        <b-input-group v-if="selectedEngagementType == 'lead'" prepend="$" class="mb-2 mt-3 mr-sm-2 mb-sm-0">
          <b-input 
            id="inline-form-input-commission" 
            type="number" 
            placeholder="Commission per lead"
            v-model="form.commission"></b-input>
        </b-input-group>        

        <b-input-group v-else append="%" class="mb-2 mt-3 mr-sm-2 mb-sm-0">
          <b-input 
            id="inline-form-input-commission" 
            type="number" 
            placeholder="Commission percentage"
            v-model="form.commission"></b-input>
        </b-input-group>

        <b-input-group class="mt-2">
          <p style="float:left;clear:both;"><b-form-checkbox
            id="checkbox-1"
            v-model="createContract"
            name="checkbox-1"
            class="mt-4"
            value="1"
            unchecked-value="0"
          >
          </b-form-checkbox>Create Contract?</p>
        </b-input-group>

        <div v-if="createContract == '1'" class="mt-2">
          <h5 class="mt-2">Signer Info</h5>
          <b-input-group class="mt-2 mb-2 mr-sm-2 mb-sm-0">
            <b-input 
              id="inline-form-input-first-name" 
              placeholder="First Name"
              v-model="form.firstName"></b-input>
          </b-input-group>
          <b-input-group class="mt-2 mb-2 mr-sm-2 mb-sm-0">
            <b-input 
              id="inline-form-input-last-name" 
              placeholder="Last Name"
              v-model="form.lastName"></b-input>
          </b-input-group>
          <b-input-group class="mt-2 mb-2 mr-sm-2 mb-sm-0">
            <b-input 
              id="inline-form-input-email" 
              placeholder="Email"
              v-model="form.email"></b-input>
          </b-input-group>
          <p class="mt-2">Creating a signer will create a client account and invite the user to the dashboard.</p>
        </div>

      </md-dialog-content>
      <md-dialog-actions>
        <md-button type="reset" class="md-primary" @click="close">Close</md-button>
        <md-button type="submit" class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
    <app-header title="Accounts"/>
    <b-card>
      <div>
        <b-button variant="primary" class="brand-purple compose-btn" @click="showDialog = true" style="float: right; margin-bottom: 16px;">
          New Account
        </b-button>
        <b-table hover :items="accounts" :fields="fields">
          <template v-slot:cell(actions)="data">
            <div class="action-container" v-if="isOwner(data) == false">
             <b-dropdown
               variant="link"
               size="lg"
               toggle-class="text-decoration-none"
               no-caret
               right
             >
               <template slot="button-content">
                 <b>⋮</b>
               </template>
               <b-dropdown-item class="edit" @click="viewDashboard(data)"><b-icon-graph-up />View Dashboard</b-dropdown-item>
               <b-dropdown-item class="edit" @click="manageUsers(data)"><b-icon-people />Manage Account</b-dropdown-item>
               <b-dropdown-divider></b-dropdown-divider>
               <b-dropdown-item class="delete" @click="deleteAccount(data)"><b-icon-trash></b-icon-trash><span>Delete Account</span></b-dropdown-item>
             </b-dropdown>
            </div>
          </template>
        </b-table>
        <spinner v-if="isLoading"></spinner>
      </div>
    </b-card>
  </div>
</template>

<script>

  import Constants from '../../../Constants'
  import axios from 'axios'
  import Spinner from '../../common/Spinner'
  import * as Swal from "sweetalert2";

  export default {
    name: "Analytics",
    components: {
      Spinner
    },
    data: () => {
      return {
        data: {
          totalRevenue: '0',
          adSpend: '0',
          roas: '0',
          totalLeads: '0'
        },
        accounts: [],
        isLoading: false,
        selectedUser: null,
        form: {
          name: '',
          commission: '',
          setupFee: '',
          firstName: '',
          lastName: '',
          email: '',
          googleDriveUrl: ''
        },
        fields: ['name', 'actions'],
        showDialog: false,
        showEditDialog: false,
        selectedEngagementType: { value: 'sales', text: 'Sales - commission %'},
        options: [
          { value: 'admin', text: 'Admin - All Access' },
          { value: 'agent', text: 'Agent - Send and receive messages' }
        ],
        engagementOptions: [
          { value: 'sales', text: 'Sales - commission %'},
          { value: 'lead', text: 'Lead - fixed cost per lead'}
        ],
        createContract: '0'
      }
    },
    methods: {
      deleteAccount: function(data) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete account!'
        }).then((result) => {
          if (result.value) {
            this.confirmDelete(data)
          }
        })
      },
      confirmDelete(data) {
        console.log('Deleting...')
        console.log(data)
        this.isLoading = true
        const id = data.item.sk
        axios.delete(Constants.API_URL + '/admin/accounts/' + id)
          .then(response => {
            this.getAccounts()
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      viewDashboard(data) {
        const id = data.item.sk
        this.$router.push('/admin/' + id + '/dashboard')
      },
      editUser: function(data) {
        console.log(data)
        this.selectedUser = data.item
        this.showEditDialog = true
      },
      manageUsers(data) {
        const id = data.item.sk
        this.$router.push('/admin/' + id + '/users')
      },
      updatePhone(data) {
        this.form.phone = data.nationalNumber
        this.form.country = data.countryCallingCode
      },
      isOwner: function(data) {
        return data.item.role == "owner"
      },
      getAccounts() {
        this.isLoading = true

        axios.get(Constants.API_URL + "/admin/accounts")
          .then(response => {
            this.accounts = response.data.Items
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      reset() {
        this.form.country = "";
        this.form.name = "";
        this.form.ph = "";
        this.form.familyName = "";
        this.form.phone = "";
      },
      close() {
        this.reset();
        this.showDialog = false
      },
      save() {
        const params = {
          name: this.form.name,
          commission: this.form.commission,
          setupFee: this.form.setupFee,
          engagementType: this.selectedEngagementType,
          createContract: this.createContract,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          googleDriveUrl: this.form.googleDriveUrl
        }

        console.log(params)
        this.isLoading = true
        axios
          .post(Constants.API_URL + "/admin/accounts", params)
          .then(response => {
            console.log(response);
            const id = response.data.sk
            this.close()

            this.$router.push('/admin/' + id + '/users')
          }).catch((err) => {
            console.error(err)
            swal('Error', 'Error creating account...', 'error')
          }).then(() => {
            this.isLoading = false
            this.getAccounts()
          })
      }
    },
    created() {
      this.getAccounts()
    }
  }
</script>

<style scoped>
  .dialog-content {
    max-height: 600px;
    width: 500px;
  }

  .country-content {
    width: 100%;
  }

  .action-container {
    margin-top: -10px;
  }

  .delete {
    color: red;
  }

  .delete svg {
    margin-right: 8px;
    color: red;
  }

  .delete span {
    color: red;
  }

  .edit svg {
    margin-right: 8px;
  }

  label .custom-control-label::after {
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/accounts/Accounts.vue